import React, { createContext, useContext } from "react";

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  // URLs hardcodadas apontando para os arquivos físicos na pasta public
  const logoUrl = "/logo.png";
  const pixQRCodeUrl = "/pix-qrcode.png";

  return (
    <ThemeContext.Provider value={{ 
      logoUrl, 
      pixQRCodeUrl,
      // Funções vazias para evitar quebra em componentes antigos
      setLogoUrl: () => {}, 
      setPixQRCodeUrl: () => {},
      refreshSettings: () => {}
    }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  return context || { 
    logoUrl: "/logo.png", 
    pixQRCodeUrl: "/pix-qrcode.png",
    setLogoUrl: () => {}, 
    setPixQRCodeUrl: () => {},
    refreshSettings: () => {}
  };
};
